import { FRONTEND_ROUTES } from "@/constants"
import { toast } from "@/hooks/use-toast"
import i18n from "@/i18n"

export const clearUserSession = async (
  authContext: AuthContextProps
) => {
  authContext.handleAuthData()
}

export const showError = (message: string) => {
  toast({ title: message, variant: "destructive" })
}

export const showSuccess = (message: string) => {
  toast({ title: message })
}

export const handleError = async ({
  authContext,
  error,
}: HandleErrorType) => {
  if (error.isForbidden) {
    const isOnLoginPage =
      typeof window !== "undefined" &&
      window.location.pathname ===
        FRONTEND_ROUTES.LOGIN.href

    if (!isOnLoginPage) {
      showError(i18n.t("apiErrors.invalidToken"))
    }

    await clearUserSession(authContext)

    if (!isOnLoginPage) {
      setTimeout(() => {
        if (typeof window !== "undefined") {
          window.location.href = FRONTEND_ROUTES.LOGIN.href
        }
      }, 1500)
    }
    return
  }
  if (error.isConnectionError) {
    showError(i18n.t("apiErrors.serverUnavailable"))
    return
  }
  showError(error.message)
}
